module.exports = __webpack_public_path__ + "img/logo_onebox-horizontal-white.3e41dee7.png";